import Accordion from './accordion.vue';
export default Accordion;


// WEBPACK FOOTER //
// ./src/components/accordion/index.js